import './Detail.css';

import { useState } from 'react';
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addItem } from '../../store';

import Modal from '../../components/Modal/Modal';
import CardSlide from '../../components/CardSlide/CardSlide';

function Detail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const isLoggedIn = useSelector(state => state.isLoggedIn);
    const cart = useSelector((state) => state.cart);
    const guitars = useSelector(state => state.guitars);
    const guitar = guitars[id];

    const [isAddToCartModalOpen, setAddToCartModalOpen] = useState(false);
    const [isNavigateToCartModalOpen, setNavigateToCartModalOpen] = useState(false);
    const [isAlreadyInCartModalOpen, setAlreadyInCartModalOpen] = useState(false);
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);

    const handleAddToCart = () => {
        if (!isLoggedIn) {
            setLoginModalOpen(true); // 로그인 확인 모달 표시
            return;
        }

        const isAlreadyInCart = cart.some((item) => item.id === guitar.id);
        if (isAlreadyInCart) {
            setAlreadyInCartModalOpen(true); // "이미 장바구니에 담겨있습니다" 모달 표시
        } else {
            setAddToCartModalOpen(true); // 장바구니 추가 확인 모달 표시
        }
    };

    const handleConfirmAddToCart = () => {
        dispatch(addItem(guitar.id));
        setAddToCartModalOpen(false); // 추가 확인 모달 닫기
        setNavigateToCartModalOpen(true); // 장바구니 이동 확인 모달 표시
    };

    const handleOrderClick = () => {
        if (!isLoggedIn) {
            setLoginModalOpen(true); // 로그인 확인 모달 표시
            return;
        }

        const isAlreadyInCart = cart.some((item) => item.id === guitar.id);
        if (isAlreadyInCart) {
            setAlreadyInCartModalOpen(true); // "이미 장바구니에 담겨있습니다" 모달 표시
        } else {
            setNavigateToCartModalOpen(true); // 장바구니 이동 확인 모달 표시
        }
    };

    const handleCancel = () => {
        setAddToCartModalOpen(false);
        setNavigateToCartModalOpen(false);
        setAlreadyInCartModalOpen(false);
        setLoginModalOpen(false);
    };

    const breadcrumbItems = [
        { name: "HOME", path: "/" },
        { name: "ELECTRIC GUITARS", path: "/shop" },
        { name: "STRATOCASTER", path: "/shop" },
        { name: guitar.title, path: `/shop/${guitar.id}` },
    ];

    return (
        <>
            <div className="detail common-padding">
                <div className='detail__left'>
                    <div className='breadcrumb-wrapper'>
                        <Breadcrumb items={breadcrumbItems} guitar={guitar}></Breadcrumb>
                    </div>
                    <img src={`${process.env.PUBLIC_URL}/guitar_detail/guitar-${guitar.id}-${guitar.title}.jpg`} alt={guitar.name} className='detail__image'></img>
                </div>
                <div className='detail__right'>
                    <h2>{guitar.title}</h2>
                    <p>{guitar.price.toLocaleString()}</p>

                    {/* 장바구니 버튼 */}
                    <button onClick={handleAddToCart}>장바구니</button>

                    {/* 장바구니 추가 확인 모달 */}
                    {isAddToCartModalOpen && (
                        <Modal
                            message={`${guitar.title}을(를) 장바구니에 담으시겠습니까?`}
                            onConfirm={handleConfirmAddToCart} // "확인" 클릭 시 handleConfirm 호출
                            onCancel={handleCancel} // "취소" 클릭 시 handleCancel 호출
                        />
                    )}

                    {/* 이미 장바구니에 담긴 경우 모달 */}
                    {isAlreadyInCartModalOpen && (
                        <Modal
                            message={
                                <>
                                    이미 장바구니에 담겨있습니다! <br />
                                    장바구니로 이동할까요?
                                </>
                            }
                            onConfirm={() => navigate('/cart')} // "확인" 클릭 시 장바구니 페이지로 이동
                            onCancel={handleCancel} // "취소" 클릭 시 모달 닫기
                        />
                    )}

                    {/* 주문하기 버튼 */}
                    <button onClick={handleOrderClick}>주문하기</button>

                    {/* 장바구니 이동 확인 모달 */}
                    {isNavigateToCartModalOpen && (
                        <Modal
                            message={
                                <>
                                    장바구니에 담았습니다! <br />
                                    장바구니로 이동할까요?
                                </>
                            }
                            onConfirm={() => {
                                handleConfirmAddToCart();
                                navigate('/cart')
                            }} // "확인" 클릭 시 장바구니 담고 장바구니 페이지로 이동
                            onCancel={handleCancel} // "취소" 클릭 시 모달 닫기
                        />
                    )}

                    {/* 로그인 필요 모달 */}
                    {isLoginModalOpen && (
                        <Modal
                            message={
                                <>
                                    로그인이 필요합니다! <br />
                                    로그인 페이지로 이동할까요?
                                </>
                            }
                            onConfirm={() => navigate('/login', { state: { from: `${location.pathname}${location.search}${location.hash}` }, replace: true })} // "확인" 클릭 시 로그인 페이지로 이동
                            onCancel={handleCancel} // "취소" 클릭 시 모달 닫기
                        />
                    )}
                </div>
            </div>
            <CardSlide></CardSlide>
        </>
    );
}

const Breadcrumb = ({ items, guitar }) => {
    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                {items.map((item, index) => (
                    <li key={index} className="breadcrumb-item">
                        {index !== items.length - 1 ? (
                            <Link to={item.path}>{item.name}</Link>
                        ) : (
                            <span>{guitar.title}</span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default Detail;
